import { createEntityFilterStore } from "./createEntityFilterStore";
import type { InvestorDocumentFilters } from "@/domain/types";

const initialFilters: InvestorDocumentFilters = {
  search: "",
  document_type: "",
  status: "",
  sort: { key: undefined, direction: null },
};

export const useInvestorDocumentFiltersStore = createEntityFilterStore<InvestorDocumentFilters>(
  "InvestorDocumentFiltersStore",
  initialFilters,
);
